import { useEffect } from 'react';
import { LandingLayout } from '@/components/landing/LandingLayout';
import { Hero } from '@/components/landing/Hero';
import { InterstitialJournaling } from '@/components/landing/InterstitialJournaling';
import { Pricing } from '@/components/landing/Pricing';
import { Platforms } from '@/components/landing/Platforms';
import { Community } from '@/components/landing/Community';
import { useLandingTheme } from '@/hooks/useLandingTheme';
import { warnIfPlaceholderRating } from '@/config/seo';

const LandingPage = () => {
  useLandingTheme();

  // No-op while APP_STORE_RATING_IS_PLACEHOLDER is false; starts warning in
  // dev again if the rating in seo.ts is ever reverted to a placeholder.
  useEffect(() => {
    warnIfPlaceholderRating();
  }, []);

  return (
    <LandingLayout>
      <div className="mx-auto w-full max-w-6xl px-6 py-12 sm:py-16">
        <Hero />
        <InterstitialJournaling />
        <Pricing />
        <Platforms />
        <Community />
      </div>
    </LandingLayout>
  );
};

export default LandingPage;
